/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme-dark/base/colors";

const { info, background, text } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    colorScheme: "dark",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  body: {
    transition: "background-color 0.3s ease",
    backgroundColor: background.default,
    color: text.main,
  },
  "::selection": {
    backgroundColor: "rgba(76, 141, 255, 0.35)",
    color: "#ffffff",
  },
  "*": {
    scrollbarColor: "rgba(148, 163, 184, 0.28) transparent",
  },
  "::-webkit-scrollbar": {
    width: 10,
    height: 10,
  },
  "::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(148, 163, 184, 0.28)",
    borderRadius: 999,
    border: `2px solid ${background.default}`,
  },
  "::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(148, 163, 184, 0.45)",
  },
  "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill":
    {
      WebkitTextFillColor: text.main,
      WebkitBoxShadow: `0 0 0 1000px ${background.elevated} inset`,
      caretColor: text.main,
      transition: "background-color 9999s ease-in-out 0s",
    },
  "input::placeholder, textarea::placeholder": {
    color: text.muted,
    opacity: 1,
  },
  hr: {
    borderColor: colors.divider,
  },
  /*
    color-scheme: dark turns the browser's default button fill into a flat
    mid-gray. Many hand-styled <button>s rely on `bgcolor: "transparent"`,
    which MUI resolves to the palette.transparent object and drops, so that
    gray showed through. Class-based styles still win over this rule.
  */
  button: {
    backgroundColor: "transparent",
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${text.main} !important`,
    transition: "color 0.2s ease !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
